(function ($, root, undefined) {  
    $(function () {

        'use strict';
		
      $(window).on('load', function(){
      	var zoom_el = $('.product-images .zoom_img_link');
        if (zoom_el.length) {
          var img = $('.zoom_img_link').find('img');
          MagicZoom.start(img.parent().get(0));
           zoom_el.each(function() {
          		MagicZoom.zoomOut(this);
        	});  
        }
      });
      
      $('.allow_submit').on('change', function() {
          var button_id = $(this).data('href');
          var is_checked = $(this).is(':checked');
          $(button_id).prop('disabled', function() {
              return !is_checked;
          });
      });           
      
      $(document).on('ready', function(){
        $('.zoom_img_link').on('click', function(e) {
        	e.preventDefault();
        });
        
        $(window).on('scroll', function(){
          if ( $('.template-collection').hasClass('products-filter-expanded') ) {
            var body_padding = parseInt($('body').css('padding-top').replace('px', ''));
            
            if ( $('.logo-wrap').length ) {
              if ( $(window).scrollTop() > body_padding ){
                $('.logo-wrap').removeClass('absolute_logo_wrap');
                $('.logo-wrap').addClass('logo-scroll-with-filters');
              }else{
                var body_padding = $('body').css('padding-top');
              	$('.logo-wrap').addClass('absolute_logo_wrap');
                $('.logo-wrap').removeClass('logo-scroll-with-filters');
              } 
            	
            }
          }else{
            if ( $('.logo-wrap').length ) {
              if ($('.logo-wrap').hasClass('absolute_logo_wrap')) {
              	$('.logo-wrap').removeClass('absolute_logo_wrap');
              }
            }
          }
        });
      });
      	
      
        mk.filtered_products = {
          class_name : null,
          variants : [],
          tags : []          
        };
        mk.product_sizes = {
          digits : [],
          letters : []
        };
        mk.product_tags = [];

        var checkRemainingFilteringCriteria = function() {
          var $all_filters = $('#products-filter-form input');
              $all_filters.removeAttr('disabled');
          var $tag_filters = $all_filters.filter('.tag');
          var $variant_filters = $all_filters.filter('.variant');
          var $filtered_products = $(mk.filtered_products.class_name);
          if (mk.filtered_products.variants.length) {
            $tag_filters.each(function() {
              var input_class_name = '.' + $(this).val();
              if ($filtered_products.filter(input_class_name).length == 0 && !$(this).is(':checked')) {
                $(this).attr({'disabled':'true'});
              }
            });
          }
          if (mk.filtered_products.tags.length) {
            $variant_filters.each(function() {
              var input_class_name = '.' + $(this).val();
              if ($filtered_products.filter(input_class_name).length == 0 && !$(this).is(':checked')) {
                $(this).attr({'disabled':'true'});
              }
            });
          }          
        };

        var filterCollectionProducts = function() {
          var product_items = $('.product-item');
          product_items.removeClass('hidden');
          if (mk.filtered_products.class_name) {
            product_items.not(mk.filtered_products.class_name).addClass('hidden').children('.page-block').removeClass('block-visible');
          }
          checkRemainingFilteringCriteria();
          handleBlocksPosition();
        };

        var sortByReference = function(arr, reference) {
          var reference_sizes_sorted = [];
          var non_reference_sizes = [];
          var result_sizes = [];
          var idx, current_size, letter_sizes = arr;
          for (var i=0; i < letter_sizes.length; i++) {
            current_size = letter_sizes[i];
            idx = reference.indexOf(current_size);
            if (idx >= 0) {
              reference_sizes_sorted[idx] = current_size;
            } else {
              non_reference_sizes.push(current_size)    
            }
          }
          for (var i=0; i < reference_sizes_sorted.length; i++) {
              if (typeof reference_sizes_sorted[i] !== 'undefined') {121
                  result_sizes.push(reference_sizes_sorted[i]);
              }
          }
          for (var i=0; i < non_reference_sizes.length; i++) {
              if (typeof non_reference_sizes[i] !== 'undefined') {
                  result_sizes.push(non_reference_sizes[i]);
              }
          }                
          return result_sizes;
        };

        var updateProductsFilterVariant = function() {
          var template = Handlebars.compile( $('#products-filter-input-template').html() );

          /* Sort variant digits */
          mk.product_sizes.digits.sort(function(a,b) {return a - b;});     
          /* Sort variant letters */
          var reference_sizes = ['os','xs','s','m','l','xl'];
          mk.product_sizes.letters = sortByReference(mk.product_sizes.letters, reference_sizes);
          /* Compile sizes */
          var variant_html_1 = template({'name' : 'variant', 'items' : mk.product_sizes.digits});          
          var variant_html_2 = template({'name' : 'variant', 'items' : mk.product_sizes.letters, 'name' : 'variant'});          
          $('#filter-variants-option').html(variant_html_1).append(variant_html_2);  

          /* Sort tags */
          mk.product_tags.sort()

          /* Compile tags */
          var tags_html = template({'name' : 'tag', 'items' : mk.product_tags});
          $('#filter-tags-option').html(tags_html);
        };

        var updateProductVariants = function($product_items) {
          $product_items.each(function() {
            var variants_str = $(this).data('variants');
            var variants = variants_str.split(' ');
            var variant, size_group;
            for (var i=0; i<variants.length; i++) {
              variant = $.trim(variants[i]);
              if (variant == 'default-title') {
                continue;
              }
              size_group = isNaN(variant) ? 'letters' : 'digits';
              if (variant !== '' && mk.product_sizes[size_group].indexOf(variant) == -1) {
                mk.product_sizes[size_group].push(variant);
              }
            }

            var tags_str = $(this).data('tags');
            var tags = tags_str.split(' '); 
            var tag;
            for (var i=0; i<tags.length; i++) {
              tag = $.trim(tags[i]);
              if (tag !== '' && mk.product_tags.indexOf(tag) == -1) {
                mk.product_tags.push(tag);
              }
            }            
          });
          updateProductsFilterVariant();
        };

        if ($('body').hasClass('template-collection')) {
          updateProductVariants($('.product-item'));
        }

        /* Redirect -- Begin */

        if ($.cookie('user_logout') == 'true') {
          $.cookie('user_logout',null, {path: '/', expires: 365});        
          window.location = '/account/login'
        }

        /* Redirect -- End */   

        /* 404 -- Begin */
        
        var set404Height = function() {
            $('#container-404').css({
                'min-height' : $(window).height() - $('.header').outerHeight() - $('.footer').outerHeight()
            });    
        };
        
        set404Height();
        
        $(window).on('resize', set404Height);
        
        /* 404 -- End */

        /* Mobile product image slider -- Begin */

        $('.product-mobile-images').slick({
          'arrows' : true
        });

        /* Mobile product image slider -- End */

        /* Country change -- Begin */

        $('select[name="address[country]"]').each(function() {
          var country = $(this).val();
          var province_label = $(this).closest('form').find('.province-label')
          if (country == 'United States') {
            province_label.text('State');
          } else {
            province_label.text(province_label.data('label'));
          }
        }).on('change', function() {
          var country = $(this).val();
          var province_label = $(this).closest('form').find('.province-label');
          if (country == 'United States') {
            province_label.text('State');
          } else {
            province_label.text(province_label.data('label'));
          }        
        });

        /* Country change -- End */

        /* Wishlist -- Begin */

        var wishlistLoaderReplace = function() {
          var wishlist_loader = $('.div-wishlist img');

          if (wishlist_loader.length) {
            wishlist_loader.each(function() {
              $('<div class="loader-div"><span class="loader"></span></div>').insertAfter($(this));
            });
          }
        }

        wishlistLoaderReplace();

        var $img = $('img[src="//shopiapps.in/wishlistapp/image/ajax-loader.gif"]');
        if ($img.length) {
          var $parent = $img.parent();
          $img.remove();
          $parent.html('<span class="loader"></span>');
          var $products_html = $('#products-html');

          var check_wishlist = setInterval(function() {
            if ($products_html.find('.loader').length == 0) {
              clearInterval(check_wishlist);
              if ($products_html.find('.prd_divv').length == 0) {
                $products_html.html('<h4 class="wishlist-empty-title">Your Wishlist is empty.</h4>');
              } else {
                var wishlist_products = $products_html.find('.prd_divv');
                wishlist_products.each(function() {
                  var prod_img = $(this).find('.prod_imgg img');
                  var prod_link = $(this).find('.prod_imgg > a');
                  var prod_id = $(this).find('.removeFavorite').attr('id');
                  var wishlist_img = $.cookie('wish-img-' + prod_id);
                  if (wishlist_img) {
                    prod_img.on('load', function() {
                      $(this).addClass('ready');
                    }).attr({ 'src' : wishlist_img });
                  } else {
                    $.ajax({
                      url: prod_link.attr('href') + '.js',
                      success: function(data) {
                        var image = null;
                        if (typeof data.images !== 'undefined' && typeof data.images[1] !== 'undefined') {
                          image = data.images[1];
                        }
                        if (image) {
                          $.cookie('wish-img-' + data.id, image, {path: '/', expires: 365});                        
                          prod_img.on('load', function() {
                            $(this).addClass('ready');
                          }).attr({ 'src' :  image });
                        }
                      },
                      dataType: 'json',
                      method: 'get'
                    });                    
                  }
                });
                wishlistLoaderReplace();
                /*
                if (typeof Currency !== 'undefined' && typeof Currency.convertAll == 'function') {
                  Currency.convertAll(shopCurrency, jQuery('.currencies span.selected').attr('data-currency'));
                }
                */
                var inner_check_wishlist = setInterval(function() {
                  if ($products_html.find(' > div').length == 0) {
                    clearInterval(inner_check_wishlist);
                    $products_html.html('<h4 class="wishlist-empty-title">Your Wishlist is empty.</h4>');
                  }                
                },50); 
              }
            }
          }, 50);
        }

        var saveWishlistImage = function($container) {
          var img_src = $container.find('.wishlist-img').val();
          var product_id = $container.find('.product-id').val();
          $.cookie('wish-img-' + product_id, img_src, {path: '/', expires: 365});
        };

        $('.add-to-cart-form .div-wishlist').on('click', function() {
          saveWishlistImage($(this).closest('.add-to-cart-form'));
        });

        $('.product-item .div-wishlist').on('click', function() {
          saveWishlistImage($(this).closest('.product-item'));
        });

        /* Wislist -- End */
      
      if( $('body').hasClass('template-product') ) {
        $('.product-description .delivery-label').insertAfter($('.product-description h1')).show();
      }
      
      if( $('body').hasClass('template-cart') ) {
        $('.cart-row').each(function() {
        	$(this).find('.delivery-label').appendTo($(this).find('.title-container').closest('.cart-cell-wrapper')).show();
        });
      }
      
        
        /* Scroll disable/enable -- Begin */
        
        var enableScroll = function() {
            $('body').off('scroll.lightbox mousewheel.lightbox touchmove.lightbox');
        };
        
        var disableScroll = function() {
            $('body').on('scroll.lightbox mousewheel.lightbox touchmove.lightbox', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            });                            
        };
        
        /* Scroll disable/enable -- End */

        /* Header nav position -- Begin */
        
        var main_nav = $('#main-nav');
        var footer = $('.footer');
        var header = $('.header');
        
        var checkScrollPosition = function() {
            var scroll_top_position = $(window).scrollTop();
            var footer_top_point = footer.offset().top;
            var main_nav_height = main_nav.height();
            var header_offset_top = header.offset().top + 115;
            var open_filter_offset = $('.page-wrapper').offset().top;
            if (scroll_top_position > header_offset_top) {
                $('body').addClass('nav-fixed');
            } else {
                $('body').removeClass('nav-fixed');
            }
            if (scroll_top_position + main_nav_height > footer_top_point - 50) {
                main_nav.css({
                    'position' : 'absolute',
                    'top' : footer_top_point - main_nav_height - 50 - open_filter_offset
                });                      
            } else {
                main_nav.css({
                    'position' : '',
                    'top' : ''
                });                            
            }            
        };
        
        checkScrollPosition();
        
        $(window).on('scroll', checkScrollPosition);
        
        /* Header nav position -- End */

        /* Header sub menu -- Begin */
        
        (function() {
                    
            var main_menu = $('#main-nav');
            var main_section = $('main');

          	var getMainSectionMinHeight = function() {
            	return $(window).height() - $('header').outerHeight() - $('footer').outerHeight() - 50;  
          	};
          
            $(window).on('resize',function() {
              main_section.css({'minHeight' : getMainSectionMinHeight()});
            });
          
            var calcSidebarMenuHeight = function() {
                var main_items_height = 0;
                var sub_items_height = 0;
                var base_items_count = main_menu.find('.menu > li').length;
                main_items_height = base_items_count * 36;
                var active_sub_menus = main_menu.find('.sub-menu.expanded');
                var active_sub_menus_count = active_sub_menus.length;
                var sub_items_count = active_sub_menus.find('> li').length;
                sub_items_height = sub_items_count * 27;
                var total_height = main_items_height + sub_items_height + active_sub_menus_count * 9;
              	var min_height = getMainSectionMinHeight();
                if (total_height < min_height) {
                  total_height = min_height;
                }
                main_section.css({'minHeight' : total_height});
            };

            

            calcSidebarMenuHeight();
        
            $('.menu a.has-child').on('click', function() {
                if ($(this).next('.sub-menu').length) {
                    $(this).next().slideToggle().toggleClass('expanded');
                    calcSidebarMenuHeight();
                    return false;
                }
            });

        })();

        
        
        /* Header sub menu -- End */
        
        /* Products list b -- Begin */

        $('.product-list-b').isotope({
          itemSelector: '.product-item',
		      percentPosition: true
        });

        /* Products list b -- End */

        /* Products list c -- Begin */

        if ($('.product-list-c').length) {

          var alignProductListC = function() {
            var is_desktop = Modernizr.mq('(min-width: 901px)');
            var is_tablet = Modernizr.mq('(min-width: 701px) and (max-width: 900px)');
            var $product_items = $('.product-item');
            var products_count = $product_items.length;
            $('.product-list-c .product-item-link').removeAttr('style');
            var i;
            var indexes = [];
            if (is_desktop) {
              for (i=0;i<products_count; i++) {
                  var j = i * 10;
                  var a = j + 2;
                  var b = j + 5;
                  if (a > products_count) {
                    break;
                  }
                  indexes.push(a);
                  indexes.push(b);
              }
            }
            if (is_tablet) {
              for (i=0;i<products_count; i++) {
                  var j = i * 6;
                  var a = j + 1;
                  var b = j + 3;                  
                  if (a > products_count) {
                    break;
                  }
                  indexes.push(a);
                  indexes.push(b);
              }
            }            
            if (indexes.length) {
              var small_item_client_rect = $product_items.eq(0).get(0).getBoundingClientRect();
              var reference_small_height = small_item_client_rect.height;
              for (i=0; i<indexes.length; i++) {
                var _page_block = $product_items.eq(indexes[i]).find('.product-item-link');
                _page_block.css({
                  'padding-bottom' : reference_small_height * 2 - 4
                });                
              }
            }
          };
          
          alignProductListC();

          var doit;

          $(window).on('resize', function() {
            clearTimeout(doit);
            doit = setTimeout(alignProductListC, 25);              
          });
        }

        /* Products list c -- End */

        /* Load more products -- Begin */                

        (function() {

            if (typeof products_pages !== 'undefined') {
                var total_loaded_pages = 1;
                var loading = false;
                var loader_container = $('#loader-container');
                var url;

                var get_more_products = function() {
                  if (products_pages.size > total_loaded_pages && !loading) {
                    if (products_pages.url.indexOf('?') >= 0) {
                      url = products_pages.url + '&page='
                    } else {
                      url = products_pages.url + '?page='
                    }
                    url = url + (total_loaded_pages + 1);
                    loading = true;
                    loader_container.addClass('loading');
                    $.get(url, function(page_body) {
                      var $products_list = $('#products-list');
                      var products_list = $(page_body).find('#products-list');
                      var products = products_list.html();
                      updateProductVariants($(products).find('.product-item'));
                      if ($products_list.hasClass('product-list-b')) {
                        $products_list.isotope( 'insert', $(products) );                      
                      } else {
                        $products_list.append(products);
                      }
                      filterCollectionProducts();                 
                      loading = false;
                      loader_container.removeClass('loading');
                      total_loaded_pages++;                
                      get_more_products();
                    });
                  }
                };

                get_more_products();
            }

        })();

        /* End */

        /* Page blocks handler -- Begin */                

        var blocks_to_show = [];

        var setBlocksOffsets = function () {
            blocks_to_show = [];
            var page_blocks = $('.page-block');

            var i = 1;
            page_blocks.each(function () {
                if (!$(this).hasClass('block-visible')) {
                    offset_value = 0;
                    if ($(this).hasClass('small-shift')) {
                        var offset_value = 12;
                    }                                        
                    if ($(this).hasClass('medium-shift')) {
                        var offset_value = 25;
                    }                    
                    if ($(this).hasClass('big-shift')) {
                        var offset_value = 50;
                    }
                    if ($(this).hasClass('huge-shift')) {
                        var offset_value = 100;
                    }                    
                    blocks_to_show.push({element: $(this), scroll_offset: offset_value});
                }
                i++;
            });

        };

        var checkBlocksPosition = function() {
          if (blocks_to_show.length) {
            var currentScrollPosition = $(window).scrollTop() + $(window).height();
            var element;
            for (var i=0; i<blocks_to_show.length; i++) {
              if (currentScrollPosition + blocks_to_show[i].scroll_offset > blocks_to_show[i].element.offset().top) {
                if (!blocks_to_show[i].element.parent().hasClass('hidden')) {
                  blocks_to_show[i].element.addClass('block-visible');
                }
              }
            }      
          }
        };

        var handleBlocksPosition = function() {
            setBlocksOffsets();
            checkBlocksPosition();            
        };

        handleBlocksPosition();

        $(window).on('scroll.page-blocks', function() {
          checkBlocksPosition();
        });

        /* Page blocks handler -- End */          

        /* Product images -- Begin */

        var $main_product_image = $('#main-product-image');
    
      	var $product_img = $('.zoom_img');
        var $product_thumbs = $('#product-thumbnails a');

        $product_thumbs.on('click', function() {
        	if (!$(this).hasClass('active')) {
	    		var href = $(this).attr('href');
// 				$main_product_image.css({
// 					'background-image': 'url(' + href + ')'
// 				}).attr({
//           'title' : $(this).attr('title')
              
//         });
//               $('.zoom_img_link').empty();
//               $('.zoom_img_link').append($('<img>').attr('src', href));
              
              
              $('.mz-lens').find('img').attr('src', href);
              	$('.zoom_img_link').attr('href', href);
              	MagicZoom.refresh(document.querySelector('.zoom_img_link'));
				$product_thumbs.removeClass('active');
				$(this).addClass('active');
                
              setTimeout(function(){
                  $product_img.attr({
                    'src': href
                  });
                }, 10);
              
        	}
        	return false;
        });

        /* Product images -- End */

        /* Product share -- Begin */

        if ($('#product-share').length) {
          $('#product-share').jsSocials({
            showLabel: false,
            showCount: false,            
            shares: ["facebook", "twitter", "pinterest"]
          });
        }

        $('.fa-weibo').on('click', function() {
            var desc = $(this).data('desc'),
                href = $(this).prop('href') ? $(this).prop('href') : document.title,
                e = encodeURIComponent,
                r = 'http://service.weibo.com/share/share.php?url=' + e(href) + '&title=' + e(desc),
                x = function() {
                    if (!window.open(r, 'weibo', 'toolbar=0,resizable=1,scrollbars=yes,status=1,width=450,height=330')) location.href = r + '&r=1'
                };
            if (/Firefox/.test(navigator.userAgent)) {
                setTimeout(x, 0);
            } else {
                x();
            }
            return false;
        });

        /* Product share -- Begin */        

        /* Product tabs -- Begin */

        $('.tab-title').on('click', function() {
          if (!$(this).hasClass('active')) {
            var $current_tab_title = $('.tab-title.active');
            var $current_tab_content = $current_tab_title.nextAll('.tab-content').eq(0);
            var $to_activate_title = $(this);
            var $to_activate_content = $to_activate_title.nextAll('.tab-content').eq(0);

            $current_tab_title.removeClass('active');
            $current_tab_content.slideUp();
            $to_activate_title.addClass('active');
            $to_activate_content.slideDown();
          }
          return false;
        });

        $('.tab-content.active').css({ 'display' : 'block' }).removeClass('active');

        /* Product tabs -- End */

        /* Mobile menus -- Begin */
        
        $(window).on('resize.mobile-menu scroll.mobile-menu', function() {
            $('.mobile-menu-container').css({
                'min-height' : window.innerHeight
            }).parent().height(window.innerHeight);
        }).trigger('resize.mobile-menu');

        var $header_mobile = $('.header .mobile');
        var $mobile_overlay = $('#mobile-overlay');
        
        var openMobileMenu = function() {
            var scrollTop = $(window).scrollTop();
            $mobile_overlay.css({'top': scrollTop });
            var style_attr = 'position: absolute; top: ' + scrollTop + 'px!important;';
            $header_mobile.attr("style", style_attr);        
            $('body').addClass('mobile-menu-visible mobile-menu-active');
            disableScroll();
        };

        $('#mobile-menu-trigger').on('click', function() {
            if ($('body').hasClass('products-filter-expanded')) {
              $('#close-products-filter').trigger('click');
              window.setTimeout(openMobileMenu, 300);
            } else {
              openMobileMenu();
            }
            return false;
        });
        
        var openMiniCart = function() {
          var scrollTop = $(window).scrollTop();
          $mobile_overlay.css({'top': scrollTop });
          var style_attr = 'position: absolute; top: ' + scrollTop + 'px!important;';
          $header_mobile.attr("style", style_attr);        
          $('body').addClass('mobile-minicart-visible mobile-minicart-active');
          disableScroll();          
        };

        $('#mobile-minicart-trigger').on('click', function() {
          if ($('body').hasClass('products-filter-expanded')) {
            $('#close-products-filter').trigger('click');
            window.setTimeout(openMiniCart, 300);
          } else {
            openMiniCart();
          }
          return false;
        });
        
        $('.mobile-overlay').on('click', function() {
            $('body').removeClass('mobile-menu-visible mobile-minicart-visible');
            window.setTimeout(function() {
                $('body').removeClass('mobile-menu-active mobile-minicart-active');    
                $header_mobile.removeAttr('style');
            }, 300);
            enableScroll();
            return false;
        });
        
        /* Mobile menus -- End */

        /* Account -- Begin */

        var account_customer_addresses = $('.customer-address');

        if (account_customer_addresses.length > 1) {
          (function() {
            var hash = window.location.hash;
            var form_id = hash.replace('#','#EditAddress_');
            var form_to_activate = $(form_id);
            if (form_to_activate.length && !form_to_activate.hasClass('active')) {
              account_customer_addresses.removeClass('active');
              form_to_activate.addClass('active');
            }
          })();
        }

        $('#customer_logout_link').on('click', function() {
          $.cookie('user_logout','true',{'path': '/'});
        });

        var $orders_history_list = $('#orders-history-list');
        var $orders_history_list_titles = $orders_history_list.find('.order-no');

        $orders_history_list_titles.on('click', function() {
          $(this).toggleClass('expanded');
          $(this).next().slideToggle();
          return false;
        });

        var $account_nav = $('.account-nav');
        var $account_nav_links = $account_nav.find('a');
        var $account_nav_select = $('<select class="account-nav-mobile sselect"></select>');
        var account_nav_options = '';

        var accountNavigationCheck = function() {
          var id = window.location.hash;
          if (id && $(id + '-section').length) {
            $('.account-section').removeClass('active');
            $(id + '-section').addClass('active');
            $account_nav_links.removeClass('active');
            $account_nav_links.filter('[href$="' + id + '"]').addClass('active');          
          } else {
            $account_nav_links.filter('[href$="' + window.location.pathname + '"]').addClass('active');
          }
        };

        if ($account_nav_links) {

          accountNavigationCheck();

          $(window).on('hashchange', accountNavigationCheck);

          $account_nav.find('a').each(function() {
            account_nav_options += '<option value="' + this.href + '" ';
            if ($(this).hasClass('active')) {
              account_nav_options += 'selected';
            }
            account_nav_options += '>' + $(this).text() + '</option>';
          });     

          $account_nav_select.on('change', function() {
            window.location = $(this).val();
          });

          $account_nav_select.html(account_nav_options).insertAfter($account_nav);     

        }

        $('.register-popup form').on('submit', function() {
          var $form = $(this);
          var messages = [];
          var message_text = '';
          var $message = $form.find('.message');
          $message.html('');
          if (!$form.find('input[type="email"]').val()) {
            messages.push("Email can't be blank.");
          }
          if (!$form.find('input[type="password"]').val()) {
            messages.push("Password can't be blank.");
          }          
          if (messages.length) {
            message_text = '<ul>';
            for (var i=0; i<messages.length; i++) {
              message_text += '<li>' + messages[i] + '</li>';
            }
            message_text += '</ul>';
            $message.html(message_text);
            return false;
          }
        });

        $('#register-link').on('click', function() {
          $('body').addClass('register-popup-visible');
          return false;
        });

        $('.close-register-popup, .register-popup-overlay').on('click', function() {
          $('body').removeClass('register-popup-visible');
          return false;
        });

        /* Account -- End */

        /* Stylish select -- Begin */

        $('.sselect').sSelect({
          'defaultText': 'Sort By'
        });

        /* Stylish select -- End */        

        /* Search -- Begin */

        $('#shop-nav .search').on('mouseenter', function() {
          $(this).addClass('hovered');
        }).on('mouseleave', function() {
          $(this).removeClass('hovered');
        });

        $('#shop-nav .search input[type="search"]').on('focus', function() {
          $(this).closest('.search').addClass('focused');
        }).on('blur', function() {
          $(this).closest('.search').removeClass('focused');
        });

        /* Search -- End */

        /* Login page -- Begin */

        function showRecoverPasswordForm() {
          document.getElementById('RecoverPasswordForm').style.display = 'block';
          document.getElementById('CustomerLoginForm').style.display='none';
        }

        $('#RecoverPassword').on('click', function() {
          showRecoverPasswordForm();
          return false;
        });

        function hideRecoverPasswordForm() {
          document.getElementById('RecoverPasswordForm').style.display = 'none';
          document.getElementById('CustomerLoginForm').style.display = 'block';
        }

        $('#HideRecoverPasswordLink').on('click', function() {
          hideRecoverPasswordForm();
          return false;
        });

        // Allow deep linking to the recover password form
        if (window.location.hash == '#recover') { showRecoverPasswordForm() }

        /* End */        

        /* Size guide -- Begin */

        var $size_guide_img = $('.product-description .description img');

        if ($size_guide_img.length) {
          $('#size-guide').show();
          $('#size-chart-placehoder').append($size_guide_img);
        }

        $('#size-guide').on('click', function() {
          $('.size-chart-popup-overlay').height($(document).height());
          $('body').addClass('size-chart-visible');
          return false;
        });

        $('.close-chart, .size-chart-popup, .size-chart-popup-overlay').on('click', function() {
          $('body').removeClass('size-chart-visible');
          return false;
        });

        /* Size guide -- End */

        /* Search form -- Begin */

        $('.search form').on('submit', function() {
          var term = $(this).find('[name="q"]').val();
          if (!$.trim(term)) {
            return false;
          }
        });

        /* Search form -- End */

        /* Product form -- Begin */

        var add_to_cart_form = $('.add-to-cart-form');
        var add_to_cart_form_message = add_to_cart_form.find('.add-to-cart-message');
        var $notify_product_size = $('#notify-product-size');
        var $notify_product_textarea = $('#notify-product-textarea');
        var $form_labels = add_to_cart_form.find('.sizes label');

        $form_labels.on('click', function() {
          if (!$(this).hasClass('selected')) {
            $form_labels.removeClass('selected');
            $(this).addClass('selected');
          }
          if ($(this).prev().attr('disabled')) {
            add_to_cart_form.addClass('size-not-available');
            $notify_product_size.text($(this).text());
            $notify_product_textarea.val($notify_product_textarea.next().text());
          } else {
            add_to_cart_form.removeClass('size-not-available');
          }
        });

        /* Product form -- End */

        /* Notify product -- Begin */
        
        $('.notify').on('click', function() {
          $('.bis-reset').click();
          return false;
        });       

        $('.close-notify-popup, .notify-popup-overlay').on('click', function() {
          $('body').removeClass('notify-popup-visible');
          $('.notify-form-container').removeClass('success');
          $form_labels.removeClass('selected');
          add_to_cart_form.removeClass('size-not-available');
          return false;
        });        

        $('#contact_form').on('submit', function() {
          var url = $(this).attr('action');
          var data = $(this).serialize();
          $.post( url, data, function( data ) {
            $('.notify-form-container').addClass('success');
          });
          return false;
        });

        /* Notify product -- End */        

        /* Products filtering -- Begin */

        (function() {

          var $body = $('body');

          var $products_filter = $('#collection-products-filter');
          var $form = $('#products-filter-form');

          $products_filter.addClass('ready');

          var toggleProductsFilter = function() {
            if ($body.hasClass('products-filter-expanded')) {
              $body.removeClass('products-filter-expanded').removeAttr('style');
              $(window).off('resize.product_filter');         
              $("html, body").animate({ scrollTop: 0 }, 300);          
            } else {
              $body.addClass('products-filter-expanded').css({'padding-top': $products_filter.outerHeight() });
              $(window).on('resize.product_filter', function() {
                $body.css({'padding-top': $products_filter.outerHeight() });
              });
              $("html, body").animate({ scrollTop: 0 }, 300);                                                                    
            }
          };

          $('#toggle-products-filter').on('click', function() {
            toggleProductsFilter();
            
            if ( $('.logo-wrap').length ){
              $('.logo-wrap').addClass('absolute_logo_wrap');
            }
            
            return false;
          });

          $('#close-products-filter').on('click', function() {
            toggleProductsFilter();
            return false;
          });

          $form.on('change', function() {
            var variants_class_names = [];
            var tags_class_names = [];
            var combined_class_names = [];
            var variant_class_name, tag_class_name;
            $(this).find('.variants-column input:checked').each(function() {
              variants_class_names.push('.' + $(this).val());
            });
            mk.filtered_products.variants = variants_class_names;
            $(this).find('.tags-column input:checked').each(function() {
              tags_class_names.push('.' + $(this).val());
            });           
            mk.filtered_products.tags = tags_class_names;

            //Combine filter class name
            if (variants_class_names.length && tags_class_names.length) {
              for (var i=0; i<variants_class_names.length; i++) {
                variant_class_name = variants_class_names[i];
                for (var j=0; j<tags_class_names.length; j++) {
                  tag_class_name = tags_class_names[j];
                  combined_class_names.push(variant_class_name + tag_class_name);
                }
              }
              mk.filtered_products.class_name = combined_class_names.join(',');
            } else if (variants_class_names.length) {
              mk.filtered_products.class_name = variants_class_names.join(',');
            } else if (tags_class_names.length) {
              mk.filtered_products.class_name = tags_class_names.join(',');
            } else {
              mk.filtered_products.class_name = null;
            }

            filterCollectionProducts();
            $('.product-list-b').isotope({
                      itemSelector: '.product-item',
                          percentPosition: true,
                     filter: '.product-item:not(.hidden)' 
        			});
          });

          $('#reset-products-filter').on('click', function() {
            $form.find('input').removeAttr('checked');
            $form.trigger('change');
            return false;
          });

        })();

        /* Products filtering -- End */

        /* Minicart -- Begin */

        var minicart_link = $('.cart-link').parent();
        var minicart_container_desktop = $('#minicart-container-desktop');
        var minicart_container = $('.minicart-container');
        var set_class_timeout;

        minicart_container_desktop.on('mouseenter', function() {
            window.clearTimeout(set_class_timeout);
        });

        var showMinicart = function(timeout) {
          if (typeof timeout == 'undefined') {
            timeout = 300;
          }
          clearTimeout(set_class_timeout);
          set_class_timeout = window.setTimeout(function() {
            minicart_container_desktop.addClass('hovered');
          }, timeout);
        };

        var hideMinicart = function(timeout) {
          if (typeof timeout == 'undefined') {
            timeout = 300;
          }  
          clearTimeout(set_class_timeout);
          set_class_timeout = window.setTimeout(function() {
            minicart_container_desktop.removeClass('hovered');
          }, timeout);        
        };

        minicart_link.on('mouseenter', showMinicart);

        minicart_link.on('mouseleave', hideMinicart);        

        (function() {

            var minicart_template = Handlebars.compile( $('#minicart-template').html() );
            var minicart = $('.minicart');

            var mkPriceConvert = function(price) {
              var current_currency = Currency.currentCurrency;
              var current_format = Currency.format;
              var converted_price = Currency.convert(price, shopCurrency, current_currency);
              var money_format = Currency.moneyFormats[current_currency][current_format];
              return Shopify.formatMoney(converted_price,money_format);
            }

            var miniCartHandler = function() {
              var cart_items_quantity = minicart.eq(0).find('.cart-row').length;
              if (cart_items_quantity > 2) {
                minicart.addClass('cart-slider');
                var rows_wrapper = minicart.find('.cart-rows-container > div');
                var prev_item = minicart.find('.prev-item');
                var next_item = minicart.find('.next-item');
                var offset = 0;
                var slideMiniCart = function() {
                  var translate = 0 - (offset * 135);
                  rows_wrapper.css({
                    'transform' : 'translateY(' +  translate + 'px)'
                  });        
                  checkButtonsActiveState();      
                };            
                var checkButtonsActiveState = function() {
                  if (offset == 0) {
                    prev_item.addClass('disabled');
                  } else {
                    prev_item.removeClass('disabled');
                  }
                  if (offset == cart_items_quantity - 2) {
                    next_item.addClass('disabled');
                  } else {
                    next_item.removeClass('disabled');
                  }
                };
                checkButtonsActiveState();
                var translate;
                prev_item.on('click', function() {
                  if (offset > 0) {
                    offset--;
                    slideMiniCart();              
                  }
                  return false;
                });
                next_item.on('click', function() {
                  if (offset + 2 < cart_items_quantity) {
                    offset++;
                    slideMiniCart();                          
                  }
                  return false;
                });
              } else {
                minicart.removeClass('cart-slider');
              }
            };  

            miniCartHandler();

            var getAndUpdateCart = function(show_minicart) {
              $.getJSON('/cart.js', function (cart, textStatus) {
                mk.cart = cart;
                updateMiniCart(cart);
                if ($('body').hasClass('nav-down')) {
                  $('body').removeClass('nav-down').addClass('nav-up');
                }            
                if (show_minicart) {
                  if (Modernizr.mq('(max-width: 1200px)')) {
                    $("html, body").animate({ scrollTop: 0 }, 1000, function() {
                      $('#mobile-minicart-trigger').trigger('click');
                    });                                                      
                  } else {
                    $("html, body").animate({ scrollTop: 0 }, 1000);                                                      
                    window.setTimeout(function() { 
                      showMinicart(250);
                      set_class_timeout = window.setTimeout(function() {
                        hideMinicart();
                      }, 3000);                                         
                    },50);
                  }
                }
              });
            };
            
            var updateCart = function(cart, line) {
              if ($('#cart-page').length == 0) {
                return false;
              }

              var subtotal_price, total_price = mkPriceConvert(cart.total_price);
              var removing_cart_rows = $('.cart-row.removing');
              if (removing_cart_rows.length > 0) {
                removing_cart_rows.each(function() {
                  $(this).slideToggle( "slow", function() {
                    $(this).remove();           
                    if (cart.item_count == 0 && $('.cart-row.removing').length == 0) {
                      $('#cart-page').html('<div class="empty-container"><h5 class="text-center">Your basket is empty.</h5></div>');
                    }              
                  });        
                });
                $('.cart-row.regular').not('.removing').each(function(idx) {
                  var index = idx + 1;
                  $(this).find('.remove-cart-item').data({'line' : index });
                  $(this).find('.change-qty').data({'line' : index });
                  $(this).attr({'id' : 'cart-row-' + index });
                });                           
              } else {
                var cart_row = $('#cart-row-' + line);
                subtotal_price = mkPriceConvert(cart.items[line - 1].line_price);    
                cart_row.find('.subtotal').text(subtotal_price);
              }  
              $('#cart-total').text(total_price);
              $('body').trigger('.cart-update');
            };

            var updateMiniCart = function(cart, cart_item_line) {
                      
                var items = [];
                var item = {};
                var data = {};
                var cart_count_html = '';
                var cart_html = '';
                var minicart_class;

                if (cart.item_count) {
                  cart_count_html = '(' + cart.item_count + ')';

                  $.each(cart.items, function(index, cartItem) {

                    /* Hack to get product image thumbnail
                     *   - Remove file extension, add _small, and re-add extension
                     *   - Create server relative link
                    */
                    var prodImg = '';
                    prodImg = $.cookie('mini-img-' + cartItem.product_id);

                    if (!prodImg) {
                      prodImg = cartItem.image ? cartItem.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') : '//cdn.shopify.com/s/images/admin/no-image-compact.gif';
                    }
                    
                    var price = mkPriceConvert(cartItem.price);

                    var description_item = cartItem.product_description;
                    if(description_item.indexOf('WARNING') >= 0){
                        cartItem.product_description = "";
                    }
                    // Create item's data object and add to 'items' array
                    item = {
                      id: cartItem.variant_id,
                      idx: index + 1,
                      url: cartItem.url,
                      quantity: cartItem.quantity,
                      image: prodImg,
                      title: cartItem.product_title,
                      price: price,
                      variant_title: cartItem.variant_title
                    };
                    items.push(item);
                  });

                  // Gather all cart data and add to DOM
                  var total_price = mkPriceConvert(cart.total_price);

                  data = {
                    items: items,
                    count: items.length,
                    totalPrice: total_price
                  }            

                  if (cart.items.length > 2) {
                    minicart_class = 'more_than_two_items';
                  } else if (cart.items.length > 1) {
                    minicart_class = 'more_than_one_item';
                  } else if (cart.items.length > 0) {
                    minicart_class = 'one_item';
                  }

                  cart_html = minicart_template(data);

                  $('.cart-count').text(items.length);
                } else {
                  cart_count_html = '';
                  cart_html = '';
                  minicart_class = 'no_items';
                  $('.cart-count').text('');
                }

                var minicartFinalActions = function() {
                  minicart.html(cart_html);
                  minicart_container.removeClass('no_items one_item more_than_one_item more_than_two_items');
                  minicart_container.addClass(minicart_class);
                  miniCartHandler();
                  var minicart_counter_text = '';
                  if (items.length > 0) {
                    minicart_counter_text = '(' + items.length +')';
                  }
                  $('.minicart-count').text(minicart_counter_text);            
                }
                var cart_row = $('.minicart .cart-row.removing');            
                if (cart_row.length) {
                  cart_row.each(function() {
                    $(this).slideToggle( "slow", function() {                  
                      minicartFinalActions();
                    });   
                  }); 
                } else {
                  minicartFinalActions();
                }    

                $('body').trigger('.cart-update');
            };

            var successTimeout;

            var addToCartCallback = function(e) {
                var form = $(this);
                var product_id = form.data('productid');
                var hidden_variant_id = form.find('#hidden-variant-id');
                var quantity_field = form.find('select[name="quantity"]');
                var quantity = quantity_field.val();
                var add_to_cart_message = form.find('.add-to-cart-message');
                add_to_cart_message.text('');

                var product_minicart_image = $('#minicart-image').attr('src');
                $.cookie('mini-img-' + product_id, product_minicart_image, {path: '/', expires: 365});

                var id_input_val;
                if (hidden_variant_id.length) {
                  id_input_val = hidden_variant_id.val();
                } else {
                  var input = form.find('[name^="id"]:checked');
                  if (input.attr('disabled')) {
                    id_input_val = null;
                  } else {
                    id_input_val = input.val();
                  }
                }

                if (!id_input_val) {
                  add_to_cart_message.html('Please select size');
                  return false;
                }

                var formData = form.serialize();
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data: formData,
                  success: function(cartdata) {
                    getAndUpdateCart(true);
                    var submit_button = form.find('button');
                    submit_button.addClass('added-to-cart');         
                    clearTimeout(successTimeout);
                    successTimeout = window.setTimeout(function() {
                      submit_button.removeClass('added-to-cart');
                    }, 5000);                            
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    // Shopify returns a description of the error in XMLHttpRequest.responseText.
                    // It is JSON.
                    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
                    var data = eval('(' + XMLHttpRequest.responseText + ')');

                    if (!!data.message) {
                      console.log(data.message + '(' + data.status  + '): ' + data.description);
                      if (typeof data.status !== 'undefined' && data.status == 422) {
                        data.description = 'Product already in basket';
                      }
                      add_to_cart_message.text(data.description);
                    } else {
                      console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
                    }
                  }
                });
                return false;
            };

            $(document).on('submit', '.add-to-cart-form', addToCartCallback); 

            $('.change-qty').on('change', function() {
              var changes = {};
              var qty = $(this).val();
              var item_line = $(this).data('line');
              var changes = {
                line: item_line,
                quantity: qty
              };          
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: changes,
                success: function(cart) {
                  mk.cart = cart;
                  updateMiniCart(cart, item_line);
                  updateCart(cart, item_line);
                },
                error: function() {
                  var data = eval('(' + XMLHttpRequest.responseText + ')');
                  if (!!data.message) {
                    console.log(data.message + '(' + data.status  + '): ' + data.description);
                  } else {
                    console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
                  }
                }
              });          
            });

              $(document).on('click', '.remove-cart-item', function() {   
                var line = $(this).data('line');
                var items_quantity = [];
                var cart_row = $('#cart-row-' + line);
                var minicart_row = $('.minicart-row-' + line);
                if (cart_row.length || minicart_row.length) {
                  cart_row.addClass('removing');
                  minicart_row.addClass('removing');
                }
                for (var i=0; i<mk.cart.items.length; i++) {
                  if (line - 1 == i) {
                    items_quantity.push(0);
                  } else {
                    items_quantity.push(mk.cart.items[i].quantity);
                  }
                }
              
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    dataType: 'json',
                    data: {updates: items_quantity},
                    success: function(cart) {
                    mk.cart = cart;
                      updateMiniCart(cart, line);
                      updateCart(cart, line); 
                    },
                    error: function(XMLHttpRequest, textStatus) {
                      var data = eval('(' + XMLHttpRequest.responseText + ')');
                      if (!!data.message) {
                        console.log(data.message + '(' + data.status  + '): ' + data.description);
                      } else {
                        console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
                      }
                    }
                });   
                return false;
              });

            })();

        /* Minicart -- End */


    });
      
      /* Header nav position -- Begin */
        
      (function() {

        var main_nav = $('#main-nav');
        var footer = $('.footer');
        var page_hero = $('#page-hero');
        var $body = $('body');

        var checkScrollPosition = function() {
          var scroll_top_position = $(window).scrollTop();
          var footer_top_point = footer.offset().top;
          var main_nav_height = main_nav.height();
          if (scroll_top_position > 115) {
            $body.addClass('nav-fixed');
          } else {
            $body.removeClass('nav-fixed');
          }
          if (page_hero.length) {
            if (scroll_top_position > page_hero.outerHeight()) {
              $body.removeClass('white-nav');
            } else {
              $body.addClass('white-nav');
            }                    
          }
          if (scroll_top_position + main_nav_height > footer_top_point - 50) {
            main_nav.css({
              'position' : 'absolute',
              'top' : footer_top_point - main_nav_height - 50
            });                      
          } else {
            main_nav.css({
              'position' : '',
              'top' : ''
            });                            
          }            
        };

        checkScrollPosition();

        $(window).on('scroll', checkScrollPosition);

      })();

      /* Header nav position -- End */
	
})(jQuery, this);
